import actionCreatorFactory from 'typescript-fsa/dist/typescript-fsa';
import { EventHandlerConfiguration } from '../../../services/account';
import { ServerType } from '../../System/systemConfig';

const actionCreator = actionCreatorFactory();

export const EVENT_HANDLER_CONFIG_LOAD = 'EVENT_HANDLER_CONFIG_LOAD';
export const eventHandlerConfigLoad = actionCreator<string>(EVENT_HANDLER_CONFIG_LOAD);

export interface EventHandlerRequest {
    server: ServerType;
    config: EventHandlerConfiguration[];
}

export const EVENT_HANDLER_CONFIG_SET = 'EVENT_HANDLER_CONFIG_SET';
export const eventHandlerConfigSet = actionCreator<EventHandlerRequest>(EVENT_HANDLER_CONFIG_SET);

export const EVENT_HANDLER_CONFIG_SET_MISSING = 'EVENT_HANDLER_CONFIG_SET_MISSING';
export const eventHandlerConfigSetMissing = actionCreator<EventHandlerRequest>(EVENT_HANDLER_CONFIG_SET_MISSING);